import {gql} from '@apollo/client'

export const GET_REMAINING_PRODUCTS_OFFERERD = gql`
  query {
    getBusinessInActiveProductOffering {
      id
      productName
      productValue
      isActive
    }
  }
`

export const ADD_NEW_PRODUCT = gql`
  mutation updateProductOffering($productInput: [productInput!]) {
    updateProductOffering(productInput: $productInput)
  }
`

export const GET_REMAINING_TEST_GROUPS_OFFERED = gql`
  query getInActiveBusinessProductGroup($productValue: String!) {
    getInActiveBusinessProductGroup(productValue: $productValue) {
      id
      productGroup
      testGroupValue
      testGroupLabel
      isBusinessCreated
      isActive
    }
  }
`

export const GET_SELECTED_PRODUCTS = gql`
  query {
    getBusinessProductOffering {
      id
      productId
      productName
      productValue
    }
  }
`

export const ADD_NEW_TEST_GROUP = gql`
  mutation addBusinessGroups($testGroupInput: [testGroupInput!]) {
    addBusinessGroups(testGroupInput: $testGroupInput)
  }
`

export const ADD_TEST_GROUP = gql`
  mutation createTestGroup($groupInput: groupInput!) {
    createTestGroup(groupInput: $groupInput)
  }
`

export const DELETE_TEST_GROUP = gql`
  mutation deleteTestGroup($id: ID!) {
    deleteTestGroup(id: $id)
  }
`

export const UPDATE_TEST_GROUP_NAME = gql`
  mutation updateGroupName($groupInput: groupInp!, $id: ID!) {
    updateGroupName(groupInput: $groupInput, id: $id)
  }
`

export const GET_ASSOCIATED_TEST_GROUPS = gql`
  query getBusinessProductGroupByProductOffering($productValue: String!) {
    getBusinessProductGroupByProductOffering(productValue: $productValue) {
      id
      productGroup
      testGroupValue
      testGroupLabel
      isBusinessCreated
    }
  }
`

export const GET_MULTIPLE_TEST_NAME_BY_PRODUCT = gql`
  query getBusinessTestByMutlipleTestGroup($productGroup: [String]) {
    getBusinessTestByMutlipleTestGroup(productGroup: $productGroup)
  }
`

export const UPDATE_MULTIPLE_TEST = gql`
  mutation updateMultipleTestNames($testNameInputs: [testNameInputs]!) {
    updateMultipleTestNames(testNameInputs: $testNameInputs)
  }
`
export const DELETE_MULTIPLE_TEST = gql`
  mutation deleteMultipleTestNames($testNameIds: [ID!]!) {
    deleteMultipleTestNames(testNameIds: $testNameIds)
  }
`

export const GET_LAB_ROOM_LIST = gql`
  query {
    getAllLabRooms {
      id
      isActive
      roomName
      roomType
      roomTypeId
    }
  }
`

export const DELETE_LAB_ROOM = gql`
  mutation deleteTestRooms($testRoomId: ID!) {
    deleteTestRooms(testRoomId: $testRoomId)
  }
`

export const ADD_NEW_LAB_ROOM = gql`
  mutation addNewLabRoom($testLabsInput: testLabsInput!) {
    addNewLabRoom(testLabsInput: $testLabsInput)
  }
`

export const UPDATE_LAB_ROOM = gql`
  mutation updateLabRoom($labRoomId: ID!, $testLabsInput: testLabsInput!) {
    updateLabRoom(labRoomId: $labRoomId, testLabsInput: $testLabsInput)
  }
`

export const GET_SCAN_AVAILABILITY_ON_DATE = gql`
  query getScanAvailabilityOnDate(
    $date: Date!
    $timeZone: String
    $businessProfileId: ID
    $labRoomId: ID
    $slotFilter: slotFilter
  ) {
    getScanAvailabilityOnDate(
      date: $date
      timeZone: $timeZone
      businessProfileId: $businessProfileId
      slotFilter: $slotFilter
      labRoomId: $labRoomId
    ) {
      slotStart
      slotEnd
      isAvailable
    }
  }
`

export const GET_SCAN_FEE = gql`
  query {
    getBusinessScanFee {
      homeCharges
      cancellationCharges
      bookingCharges
      platformFees
      platformFeesType
    }
  }
`

export const CREATE_APPOINTMENT = gql`
  mutation createDiagnosisAppointment($appointmentInput: ScanAppointmentInput!) {
    createDiagnosisAppointment(appointmentInput: $appointmentInput)
  }
`

export const CREATE_APPOINTMENT_FROM_CONSUMER_SIDE = gql`
  mutation createDiagnosisAppointmentV2($id: ID!, $appointmentInput: ScanAppointmentInput!) {
    createDiagnosisAppointmentV2(id: $id appointmentInput: $appointmentInput)
  }
`

export const REVERSE_SCAN_APPOINTMENT_TIMESLOT = gql`
mutation reserveScanAppointmentTimeSlot($appointmentInput: tempAppointmentInput!) {
  reserveScanAppointmentTimeSlot(appointmentInput: $appointmentInput) {
    operationStatus
    holdDuration
    tempAppointmentId
    __typename
  }
}
`


